import { Amplify, Auth } from 'aws-amplify';

import { AmplifyStorage } from './amplifyStorage';

import type { AuthorizationInfoEntity } from '@/app/api/baseApi';
import { COGNITO_REGION } from '@/config';
import { authenticationMethodType } from '@/constants';
// NOTE: jsonのプロファイルを利用する。sessionLoader関数は、baseApi.tsのCreateApi関数から呼ばれているため
import { serviceProfile as jsonServiceProfile } from '@/profile/serviceProfile';

export const amplifyMemoryStorage = new AmplifyStorage();

// 取得したuser pool情報でAmplifyを設定
export function setAmplifyConfig(
  authorizationInfo: AuthorizationInfoEntity,
  isPreview = false
): void {
  if (
    jsonServiceProfile.cuconConfig.authenticationMethod ===
    authenticationMethodType.ADMIN_TOKEN
  ) {
    Amplify.configure({
      Auth: {
        region: COGNITO_REGION,
        userPoolId: authorizationInfo.userPoolId,
        userPoolWebClientId:
          authorizationInfo?.clientIds ?? authorizationInfo?.clientId,
      },
      ...(isPreview && { storage: amplifyMemoryStorage }),
    });
  } else {
    Amplify.configure({
      Auth: {
        region: COGNITO_REGION,
        userPoolId: authorizationInfo.userPoolId,
        userPoolWebClientId:
          authorizationInfo?.clientIds ?? authorizationInfo?.clientId,
      },
      storage: amplifyMemoryStorage,
    });
  }
}

export async function sessionLoader(): Promise<
  { ownerId: string; tenantId: string; idToken: string } | undefined
> {
  try {
    // Auth.currentSession() でtokenの有効性チェックと、無効ならrefreshTokenを使用してtokenが自動的に再取得される
    const response = await Auth.currentSession();
    const idToken = response.getIdToken().getJwtToken();
    const ownerId = response.getIdToken().payload['custom:canal:user'];
    const tenantId = response.getIdToken().payload['custom:canal:tenant'];

    return { ownerId: ownerId ?? '', tenantId: tenantId ?? '', idToken };
  } catch (error) {
    console.error('Catch sessionLoader: ', error);
    if (
      // NOTE: jsonのプロファイルを利用する。baseApi.tsからimportしているメソッドのため
      jsonServiceProfile?.cuconConfig?.authenticationMethod ===
      authenticationMethodType.TOKEN
    ) {
      window.location.replace('/signin');
    }
  }
}

/**
 * サインアウトする
 * - サインアウトに成功したら、認証情報を削除する。
 *
 * @param params
 * @returns
 */
export const amplifySignOut: typeof Auth.signOut = async (opts) => {
  return Auth.signOut(opts).then(async (res) => {
    return Promise.resolve(res);
  });
};
